export enum OfflineDataType {
	JobDigitalLogFormResult = 'JDLFR' 
}